type ViewTransitionDocument = Document & {
  startViewTransition?: (callback: () => void) => unknown
}

export const runWithViewTransition = (
  callback: () => void,
  ownerDocument: Document | undefined = typeof document === "undefined" ? undefined : document,
) => {
  if (!ownerDocument) {
    callback()
    return false
  }

  const viewTransitionDocument = ownerDocument as ViewTransitionDocument
  if (typeof viewTransitionDocument.startViewTransition === "function") {
    Reflect.apply(viewTransitionDocument.startViewTransition, viewTransitionDocument, [callback])
    return true
  }

  callback()
  return false
}
